import type { Account as AccountModel } from '@/adapters/catalogv1.g';

/**
 * Transform a backend Account model to a frontend CatalogAccount type.
 * @param model - API Account response from catalog
 * @returns CatalogAccount - UI-friendly Account object
 */
export function extractAccount(model: AccountModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.account_ref ?? '',
    name: model.name ?? '',
    displayName: model.display_name ?? '',
    accountType: model.account_type ?? '',
    enabled: model.enabled ?? false,
    firstName: model.first_name,
    lastName: model.last_name,
    middleName: model.middle_name,
    description: model.description,
    primaryEmail: model.primary_email?.address,
    alternateEmails: model.alternate_emails?.map((e) => e.address ?? '') ?? [],
    primaryPhone: model.primary_phone?.number,
    createdAt: model.created_at ? new Date(model.created_at) : undefined,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogAccount = ReturnType<typeof extractAccount>;
